fx.ns("repositories", class ProductRepository extends fx.ModelArray {

	constructor(data)
	{
		super(data);

        this._cache = {};
        this.endpoint = "/app/products";
	}

    load(product_type_id, id_lang)
    {
        if (this._cache[product_type_id + "-" + id_lang])
            this.event("products-loaded");
        else
            this.post( { action : "load", 
                         product_type_id : product_type_id,
                         id_lang : id_lang }, 
                         this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
        {
            this.event("load-products-error", data);
        }
        else
        {
            this._cache[data.product_type_id + "-" + data.id_lang] = data.elements;

            if (data.elements.length > 0)
                this.addItem(data.elements);

            this.event("products-loaded");
        }
    }

    onUpdated(action)
    {
        // case when a media is deleted, we need to delete ProductMedia also
        if (action.type == "delete")
        {
            if (action.model instanceof models.ThemeLayout ||
                action.model instanceof models.Sticker ||
                action.model instanceof models.Background ||
                action.model instanceof models.Text )
            {
                for(let i = 0; i < this.length; i++)
                {
                    let product = this.getItemAt(i);
                    for(let j = 0; j < product.medias.length; j++)
                    {
                        let media = product.medias.getItemAt(j);
                        if (media.media_id == action.model.id)
                            media.delete();
                    }
                }
            }
        }
        
    }


});